import { Spacing } from '@squareup/dex-ui-shared-base';
import { MarkdownLayout } from '@squareup/dex-ui-shared-markdown-layout';
import React, { FC, PropsWithChildren } from 'react';

interface MdxLayoutProps {
  direction?: 'row' | 'col';
  justify?: 'space-between' | 'space-evenly' | 'start' | 'end';
  spaceAbove?: Spacing;
  hideWhen?: 'mobile' | 'desktop';
  wrap?: boolean;
  type?: 'grid' | 'flex';
}

const MdxLayout: FC<PropsWithChildren<MdxLayoutProps>> = ({
  children,
  ...props
}) => {
  return <MarkdownLayout {...props}>{children}</MarkdownLayout>;
};

MdxLayout.displayName = 'MdxLayout';

export { MdxLayout };
